import {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {
    Reservation
} from "crqlar-react-common/dist/models/reservation/reservation.model";
import {Resource} from "crqlar-react-common/dist/models/resource/resource.model";
import ReservationPreviewCardContent from "./ReservationPreviewCardContent";

interface Props {
    reservation: Reservation;
    profiles: Profile[];
    accommodationResources?: Resource[];
    sourceTableName?: string;
    targetTableName?: string;
    accommodationStayRange?: string;
}

const RestaurantReservationPreviewCard: React.FC<Props> = ({
                                                               reservation,
                                                               profiles,
                                                               accommodationResources,
                                                               sourceTableName,
                                                               targetTableName,
                                                               accommodationStayRange,
                                                           }) => {
    return (
        <ReservationPreviewCardContent
            reservation={reservation}
            profiles={profiles}
            accommodationResources={accommodationResources}
            sourceTableName={sourceTableName}
            targetTableName={targetTableName}
            accommodationStayRange={accommodationStayRange}
        />
    );
};

export default RestaurantReservationPreviewCard;
